<template>

  <v-container fluid fill-height pa-0>

    <v-layout column fill-height ma-0 pa-0>

      <v-layout fill-height ma-0 pa-0 >

        <v-flex xs12 >

          <v-layout fill-height column  ma-0 pa-0 >
           
            <scroll-area>
              <template slot="header">

                <v-toolbar class="active" :height="44" flat dark>
                  <v-toolbar-title>
                    <span class="body-2 uppercase blacktext--text">{{ $t('book') }} {{ $t(getActiveTree.name) }}</span>
                  </v-toolbar-title>

                  <v-layout fill-height justify-end align-center>

                    <v-tooltip dark color="secondary" bottom>
                      <v-btn icon flat slot="activator" 
                      :data-testid="$options.name + '__btn__' + 'onAdd'" 
                      @click="() => onAdd()">
                        <svg-icon
                          :color="'whblacktextite'"
                          :name="'add'"
                          width="20"
                        />
                      </v-btn>
                      <span>{{ $t('add') }}</span>
                    </v-tooltip>

                    <!-- <v-tooltip v-if="!edit" dark color="secondary" bottom>
                      <v-btn icon flat slot="activator" 
                      :data-testid="$options.name + '__btn__' + 'edit'" 
                      @click="() => {edit = !edit}">
                        <svg-icon
                          :color="'blacktext'"
                          :name="'edit'"
                          width="20"
                        />
                      </v-btn>
                      <span>{{ $t('edit') }}</span>
                    </v-tooltip>

                    <v-tooltip v-if="edit" dark color="secondary" bottom>
                      <v-btn icon flat slot="activator"  
                      :data-testid="$options.name + '__btn__' + 'close'" 
                      @click="() => {edit = !edit}">
                        <svg-icon
                          :color="'blacktext'"
                          :name="'close'"
                          width="20"
                        />
                      </v-btn>
                      <span>{{ $t('close') }}</span>
                    </v-tooltip> -->

                  </v-layout>

                </v-toolbar>

              </template>

              <template slot="body">

                <v-layout column fill-height justify-start ma-0 pa-0 >

                  <scroll-table
                    :data="getTable"
                    :options="getOptions"
                    :sortable="true"
                    :sorted="sort"
                    :subscribed="false"
                    :headUppercase="false"
                    :translate="true"
                    :hideValues="['undefined', 'null']"
                    @select=""
                    @value="(payload)=>onSelect(payload)"
                    @sort="(item) => sortTable(item)"
                  />

                </v-layout>

              </template>

            </scroll-area>
          </v-layout>

        </v-flex>
        
      </v-layout>

    </v-layout>

    <v-dialog persistent v-model="dialog.open" max-width="1000px" v-if="dialog.open">
      <book-card
        :data="getDialogData"
        :childrenMeta="getDialogData"
        :addMode="getAddMode"
        @update="(payload) => onUpdate(payload)"
        @add="(payload) => onCreate(payload)"
        @remove="(payload) => onRemove(payload)"
        @close="() => onDialogClose()"
      />
    </v-dialog>

  </v-container>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'
import bookCard from '@/nms/pages/configuration/components/book-card.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import { mapGetters } from 'vuex'
import licenseDescriptor from '@/nms/pages/configuration/components/descriptor/license_book.js'
import organizationDescriptor from '@/nms/pages/configuration/components/descriptor/organization_book.js'
import projectDescriptor from '@/nms/pages/configuration/components/descriptor/project_book.js'
import personDescriptor from '@/nms/pages/configuration/components/descriptor/person_book.js'

// Типы
interface StructureState {
  settings: {
    treeActive: Array<{ id?: string; [key: string]: any }>
  }
}

interface RootState {
  structure: StructureState
}

interface DialogState {
  open: boolean
  addMode: boolean
  data: any | null
}

interface TableColumn {
  title: string
  value: string
  type: string
  width: string
  noTranslate?: boolean
}

interface TableRow {
  name?: string
  id?: string
  type_auth?: string
  role?: string
  email?: string
  sms_phone?: string
  $id?: string
  [key: string]: any
}

interface TableData {
  columns: TableColumn[]
  rows: TableRow[]
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface OptionsData {
  columns: OptionsColumns
}

interface BookData {
  $id?: string
  name?: string
  [key: string]: any
}

interface UpdateData {
  user: BookData
  data: Record<string, any>
}

interface UsersFolder {
  $id?: string
  [key: string]: any
}

export default Vue.extend({
  name: 'BOOKS',

  components: {
    scrollArea,
    scrollTable,
    bookCard,
    svgIcon
  },

  props: {},

  data(): {
    currentActiveTree: string
    currentBook: BookData | null
    dialog: DialogState
    edit: boolean
    model: Record<string, any>
    options: OptionsData
    search: string
    sort: string
    table: TableData
  } {
    return {
      currentActiveTree: '',
      dialog: {
        open: false,
        addMode: false,
        data: null,
      },
      edit: false,
      model: {},
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '40%' },
          actions: { width: '40%' },
          check: { width: '20%' },
          check_dependence: { width: '5%' },
        },
      },
      search: '',
      sort: '',
      table: {
        columns: [
          {
            title: 'name',
            value: 'name',
            type: 'text',
            noTranslate: true,
            width: '30%',
          },
        ],
        rows: [],
      },
    }
  },

  computed: {
    getData(): any {
      return this.data
    },

    getDialogData(): any | null {
      return this.dialog.data
    },

    getAddMode(): boolean {
      return this.dialog.addMode
    },

    getTable(): TableData {
      const t = this.$merge({}, this.table) as TableData

      if (this.search.length) {
        const searchLower = this.search.toLowerCase()
        t.rows = t.rows.filter(row => {
          return row.name?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.id?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.type_auth?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.role?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.email?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.sms_phone?.toLowerCase().indexOf(searchLower) > -1
        })
      }

      if (this.sort) {
        const isDescending = this.sort.charAt(0) === '-'
        const fieldName = isDescending ? this.sort.slice(1) : this.sort
        const direction = isDescending ? -1 : 1
        t.rows = [...t.rows].sort(this.$compare(fieldName, direction))
      }

      return t
    },

    getOptions(): OptionsData {
      return this.options
    },

    getActiveTree(): { id?: string; [key: string]: any } | undefined {
      const state = this.$store.state as unknown as RootState
      let activeTree = state.structure.settings.treeActive?.[0]
      return activeTree
    },

    ...mapGetters(['getBooks']),
  },

  watch: {
    getActiveTree: {
      handler(newVal: string): void {
        if(!newVal) return
        if (this.currentActiveTree == newVal.id) return
        this.currentActiveTree = newVal.id
        this.edit = false
        this.setup()
      },
      deep: true
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      this.prepareTable()
    },

    async prepareTable(): Promise<void> {

      try {
        let book
        let bookName
        let activeBook = this.getActiveTree
        
        if(activeBook && activeBook.id && activeBook.id.slice(-5) == '_book') {
          bookName = activeBook.id.slice(0, -5)
          book = this.getBooks.find(book => book.name == bookName)
          if(book) {
            this.currentBook = book
          }
          console.log(this.$options.name, 'prepareTable', 'bookName', bookName)
        }

        if(!bookName || !book) return
        console.log(this.$options.name, 'prepareTable', 'book', book)
        console.log(this.$options.name, 'prepareTable', 'bookName', bookName)
        let descriptor
        if(bookName == 'organization') {
          descriptor = organizationDescriptor
        }
        if(bookName == 'project') {
          descriptor = projectDescriptor
        }
        if(bookName == 'license') {
          descriptor = licenseDescriptor
        }
        if(bookName == 'person') {
          descriptor = personDescriptor
        }
        console.log(this.$options.name, 'prepareTable', 'descriptor', descriptor)
        if(descriptor) {
          this.table.columns = descriptor.columns
        }

        let rows_ = []

        if(book.children?.length) {
          rows_ = book.children.map(child => {
            if(child.refs?.length) {
              child.refs.forEach(ref => {
                child[ref.ref] = ref.name
              })
            }
            return child
          }) 
        }
        this.$set(this.table, 'rows', rows_)
        // this.table.rows = rows_
        return 
      }
      catch (error) {
        console.error(this.$options.name, 'prepareTable smth wrong', error)
      }
    },

    onAdd(): void {
      // console.log(this.$options.name, 'onAdd', 'getActiveTree', this.getActiveTree)
      // console.log(this.$options.name, 'onAdd', 'currentBook', this.currentBook)
      if(this.getActiveTree?.id) {
        let bookName = this.getActiveTree.id.slice(0, -5)
        let book = this.getBooks.find(book => book.name == bookName)
        // console.log(this.$options.name, 'onAdd', 'book', book)
        if(book?.childrenMeta?.cls) {
          this.$set(this.dialog, 'data', book.childrenMeta)
        }
      }
      
      this.$set(this.dialog, 'addMode', true)
      this.$set(this.dialog, 'open', true)
    },

    onSelect(val: TableRow): void {
      // console.log(this.$options.name, 'onSelect', 'val', val)
      if (val) {
        this.$set(this.dialog, 'data', val)
        this.$set(this.dialog, 'addMode', false)
        this.$set(this.dialog, 'open', true)
      }
    },

    onDialogClose(): void {
      // console.log(this.$options.name, 'onDialogClose')
      this.$set(this.dialog, 'data', null)
      this.$set(this.dialog, 'addMode', false)
      this.$set(this.dialog, 'open', false)
    },

    async onUpdate(val: UpdateData): Promise<void> {
      // console.log(this.$options.name, 'onUpdate', 'val', val)
      if (!val.item?.$id) return

      try {
        const item = await this.$bridge.getObjectById(val.item.$id)
        // console.log(this.$options.name, 'onUpdate', 'item', item)

        if (item) {
          const data$ = val.data
          const u = await item.update(data$)
          if (u) {
            // console.log(this.$options.name, 'onUpdate', 'u', u)
            this.$dialog.notify.success(this.$getTranslate('update success'), { timeout: 5000 })
            await this.$store.dispatch('loadBooks')
            this.setup()
          } else {
            this.$dialog.notify.error('Ошибка обновления', { timeout: 5000 })
            console.error('CATCH', 'USERS', 'onUpdate', 'smth wrong')
          }
        }
      } catch (error) {
        this.$errorHandler(error)
        console.error(this.$options.name, 'onUpdate smth wrong', error)
      }
    },

    async onCreate(val: Record<string, any>): Promise<void> {
      try {
        // console.log(this.$options.name, 'onCreate', 'val', val)
        // console.log(this.$options.name, 'onAdd', 'currentBook', this.currentBook)
        if(this.currentBook?.$id && this.currentBook?.childrenMeta?.cls) {
          let book = await this.$bridge.getObjectById(this.currentBook.$id)

          if(val.full_name && !val.name) {
            let name = `${val.full_name}_$${Math.round(Math.random() * 10000000000)}`
            this.$set(val, 'name', name)
          }
          if(!val.full_name && !val.name) {
            let name = `no_full_name_$${Math.round(Math.random() * 10000000000)}`
            this.$set(val, 'name', name)
            if(val.hasOwnProperty('full_name')){
              this.$set(val, 'full_name', '')
            }
          }

          let u = await book.createChild(this.currentBook.childrenMeta.cls, val)
          if (u) {         
            this.$dialog.notify.success('Успешно добавлено!', { timeout: 5000 })
            await this.$store.dispatch('loadBooks')
            this.onDialogClose()
            this.setup()
            
          }
        }
      } catch (error) {
        console.error(this.$options.name, 'onCreate smth wrong', error)
        this.$errorHandler(error)
      }
    },

    async onRemove(val: TableRow): Promise<void> {
      try {
        // console.log(this.$options.name, 'onRemove', 'val', val)
        if(!val.$id) {
          this.$dialog.notify.error('Ошибка удаления!', { timeout: 5000 })
          return
        }
        const obj = await this.$bridge.getObjectById(val.$id)
        if (obj) {
          const d = await obj.delete()
          if (d) {
            this.$dialog.notify.success('Успешно удалено!', { timeout: 5000 })
            await this.$store.dispatch('loadBooks')
            this.onDialogClose()
            this.setup()
            
          }
        }
      } catch (error) {
        console.error(this.$options.name, 'onRemove smth wrong', error)
        this.$errorHandler(error)
      }
    },

    sortTable(item: TableColumn): void {
      if (this.sort === item.value) {
        this.sort = '-' + item.value
      } else {
        this.sort = item.value
      }
    },
  },
})
</script>

<style lang="css" scoped>
</style>
